import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './responsive.css';
import { instalarVerComo } from './utils/verComo';

// Antes de o App ler o login: na aba do "ver como" ele mora no sessionStorage.
instalarVerComo();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
